import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.includes.js";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
import { store } from '@/store';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import Logger from 'js-logger';

var updateUrlParams = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(transaction) {
    var _transaction$pin;

    var urlParams, paramsChanged;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            urlParams = store.getters['checkIn/urlParams'];
            paramsChanged = false;

            if (transaction !== null && transaction !== void 0 && (_transaction$pin = transaction.pin) !== null && _transaction$pin !== void 0 && _transaction$pin.sourceType) {
              urlParams.urlSrc = transaction.pin.sourceType;
              paramsChanged = true;
            }

            if (transaction !== null && transaction !== void 0 && transaction.pveQueueId) {
              urlParams.pveQueueId = transaction.pveQueueId;
              paramsChanged = true;
            }

            if (!paramsChanged) {
              _context.next = 7;
              break;
            }

            _context.next = 7;
            return store.dispatch('checkIn/cleanParams', urlParams);

          case 7:
            return _context.abrupt("return", true);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function updateUrlParams(_x) {
    return _ref.apply(this, arguments);
  };
}();

export default {
  cleanParams: function () {
    var _cleanParams = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
      var urlParams, nonMapped, key, value;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              urlParams = {};
              nonMapped = ['account', 'bookingRef', 'checkId', 'locationId', 'siteId', 'tableId', 'api', 'pveQueueId'];

              for (key in params) {
                value = params[key];

                if (nonMapped.includes(key)) {
                  urlParams[key] = value;
                }
              }

              return _context2.abrupt("return", urlParams);

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function cleanParams(_x2) {
      return _cleanParams.apply(this, arguments);
    }

    return cleanParams;
  }(),
  fetchTransactionData: function () {
    var _fetchTransactionData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(isTableNumber) {
      var _store$getters$questi, _transaction$pin2, _transaction$transact, _transaction$pin3;

      var branchId, isApp, survey, templateId, urlParams, pinType, pin, date, params, res, transaction, datetime, _transaction$transact2, _transaction$transact3, _transaction$transact4, _transaction$transact5;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              branchId = store.getters['config/branchId'];
              isApp = process.env.APP_FOR_WEB;
              survey = cloneDeep(store.getters['surveys/survey'](store.getters['surveys/surveyInProgress']));
              templateId = survey ? survey.templateId : null;
              urlParams = store.getters['checkIn/urlParams'];
              pinType = !(urlParams || {}).pve || isApp ? 'pin' : 'pve';
              pin = store.getters['checkIn/transactionRef'];
              date = (_store$getters$questi = store.getters['questions/getVisitDatetime']) === null || _store$getters$questi === void 0 ? void 0 : _store$getters$questi.format('YYYY-MM-DD HH:mm');
              params = {
                branchId: branchId,
                templateId: templateId,
                pinType: pinType,
                date: date
              };

              if (isTableNumber) {
                params.tableId = store.getters['checkIn/tableNumber'];
              } else {
                params.pin = pin;
              }

              if (!isApp) {
                _context3.next = 14;
                break;
              }

              params['date'] = moment().format('YYYY-MM-DD HH:mm');
              _context3.next = 24;
              break;

            case 14:
              ['checkId', 'txSource', 'api'].forEach(function (key) {
                if (urlParams[key]) {
                  params[key] = urlParams[key];
                }
              });

              if (urlParams.dateTime) {
                params.date = urlParams.dateTime;
              }

              Logger.debug('Fetch Transaction: ', urlParams);

              if (!(!pin && !urlParams.checkId || !survey.eposEnabled && pinType != 'pve')) {
                _context3.next = 21;
                break;
              }

              _context3.next = 20;
              return store.dispatch('checkIn/setTransactionRef', null);

            case 20:
              return _context3.abrupt("return", false);

            case 21:
              if (!(!templateId && (!pin || !urlParams.checkId))) {
                _context3.next = 24;
                break;
              }

              Logger.debug('fetchTransactionData requires both templateId and transactionRef to be set');
              return _context3.abrupt("return", false);

            case 24:
              _context3.next = 26;
              return store.$api.fetchTransactionData(params);

            case 26:
              res = _context3.sent;
              transaction = res === null || res === void 0 ? void 0 : res.data;

              if (isApp && (transaction || {}).branch) {
                delete transaction.branch;
              }

              if (transaction) {
                _context3.next = 32;
                break;
              }

              Logger.debug('failed to get transaction data');
              return _context3.abrupt("return", false);

            case 32:
              if (!((!pin || pinType == 'pve') && (_transaction$pin2 = transaction.pin) !== null && _transaction$pin2 !== void 0 && _transaction$pin2.pinCode)) {
                _context3.next = 37;
                break;
              }

              _context3.next = 35;
              return store.dispatch('checkIn/setTransactionRef', transaction.pin.pinCode);

            case 35:
              _context3.next = 40;
              break;

            case 37:
              if (!(pinType == 'pve')) {
                _context3.next = 40;
                break;
              }

              _context3.next = 40;
              return store.dispatch('checkIn/setTransactionRef', null);

            case 40:
              datetime = null; // If App set transaction data regardless if transactions are coming back to allow for error handling

              if (!(isApp || (_transaction$transact = transaction.transaction) !== null && _transaction$transact !== void 0 && _transaction$transact.check)) {
                _context3.next = 45;
                break;
              }

              _context3.next = 44;
              return store.dispatch('checkIn/setTransactionData', {
                transaction: transaction
              });

            case 44:
              if ((_transaction$transact2 = transaction.transaction) !== null && _transaction$transact2 !== void 0 && (_transaction$transact3 = _transaction$transact2.check) !== null && _transaction$transact3 !== void 0 && _transaction$transact3.checkOpenTime && moment((_transaction$transact4 = transaction.transaction) === null || _transaction$transact4 === void 0 ? void 0 : (_transaction$transact5 = _transaction$transact4.check) === null || _transaction$transact5 === void 0 ? void 0 : _transaction$transact5.checkOpenTime).isValid()) {
                datetime = moment(transaction.transaction.check.checkOpenTime);
              }

            case 45:
              if (datetime == null && (_transaction$pin3 = transaction.pin) !== null && _transaction$pin3 !== void 0 && _transaction$pin3.dateTime && moment(transaction.pin.dateTime).isValid()) {
                datetime = moment(transaction.pin.dateTime);
              }

              if (!datetime) {
                _context3.next = 49;
                break;
              }

              _context3.next = 49;
              return store.dispatch('checkIn/setVisitDatetime', datetime);

            case 49:
              if (!(transaction !== null && transaction !== void 0 && transaction.branch)) {
                _context3.next = 53;
                break;
              }

              store.commit('checkIn/setBranches', [transaction.branch]);
              _context3.next = 53;
              return store.dispatch('config/setBranchByField', {
                id: transaction.branch.id
              });

            case 53:
              if (isApp) {
                _context3.next = 56;
                break;
              }

              _context3.next = 56;
              return updateUrlParams(transaction);

            case 56:
              return _context3.abrupt("return", true);

            case 57:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function fetchTransactionData(_x3) {
      return _fetchTransactionData.apply(this, arguments);
    }

    return fetchTransactionData;
  }()
};